/// <reference path="../_references.ts"/>

module App.Administrative.Inventory {

    import User = App.User.User;
	export type Item = {
        id: number;
        name: string;
        description: string;
        favorited: boolean;
    }

    export type SearchParams = {
        search?: string;
        inventory_group?: number;
        inventory_sets?: number;
        sub_category?: number;
        category?: number;
        service_request?: number;
        favorites?: boolean;
        size?: number;
        page?: number;
    }

    export type Inventory = {
        id: number;
        quantity: number;
        inventory: Item;
        cost: number;
    }

	export type InventoryReplenishment = {
        id: number;
        service_request: number;
		user: User;
        appointment: {id: number, technician: Technician};
        inventories: Inventory[];
        truck: string;
        total: number;
        created: string;
        warehouse: Warehouse;
    }

    export type Technician = {
        id: number;
        full_name: string;
    }

    export type InventoryDetails = {
        id: number;
        name: string;
        image: string;
        category: { id: number, name: string };
        sub_category: { id: number, name: string };
        description: string;
        inventory_group: InventoryGroup;
        inventory_sets: InventorySet[];
        supplier: string;
        cost: number;
        favorited: boolean;
        quantity: number;
        warehouse: Warehouse;
    }

    export type InventoryGroup = {
        id: number;
        categories: { id: number, name: string }[];
        name: string;
    }

    export type InventoryCategory = {
        id: number;
        name: string;
    }

    export type InventorySubCategory = {
        id: number;
        name: string;
        category: InventoryCategory;
    }

    export type InventoryReplenishmentCreate = {
        inventories: InventoryCreate[];
		appointment?: number;
		warehouse?: number;
		user?: User;
    }

    export type InventoryCreate = {
        quantity: number;
        inventory: number;
    }

    export type CustomInventory = {
		name: string;
		cost: number;
		service_request: number;
	}

	export type InventorySet = {
		id: number;
		name: string;
	}

	export type Warehouse = {
		id: number;
		name: string;
		inventory_set: InventorySet;
		user: User;
	}
}